<template>
  <div class="bg-white">
    <div class="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-16">
      <div class="space-y-12">
        <div
          class="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none"
        >
          <h2
            class="text-3xl font-extrabold tracking-tight sm:text-4xl text-red-600"
          >
            Náš Team
          </h2>
          <!-- <p class="text-xl text-gray-500">Odio nisi, lectus dis nulla. Ultrices maecenas vitae rutrum dolor ultricies donec risus sodales. Tempus quis et.</p> -->
        </div>

        <!-- TECHNICIANS TEAM -->
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-red-600">Laboratoř</h3>

          <ul
            class="grid grid-cols-2 gap-x-6 gap-y-12 sm:grid-cols-3 lg:grid-cols-4 lg:gap-x-8"
          >
            <li v-for="person in technicians" :key="person.name">
              <div class="space-y-4">
                <div class="aspect-w-2 aspect-h-3">
                  <img
                    class="object-cover shadow-lg rounded-lg"
                    :src="person.imageUrl"
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div class="space-y-2">
                  <div class="text-lg leading-6 font-medium space-y-1">
                    <h3>{{ person.name }}</h3>
                    <p class="text-red-600">{{ person.role }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- CAD TEAM -->
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-red-600">CAD</h3>

          <ul
            class="grid grid-cols-2 gap-x-6 gap-y-12 space-y-0 sm:grid-cols-3 lg:grid-cols-4 lg:gap-x-8"
          >
            <li v-for="person in techniciansCad" :key="person.name">
              <div class="space-y-4">
                <div class="aspect-w-2 aspect-h-3">
                  <img
                    class="object-cover shadow-lg rounded-lg"
                    :src="person.imageUrl"
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div class="space-y-2">
                  <div class="text-lg leading-6 font-medium space-y-1">
                    <h3>{{ person.name }}</h3>
                    <p class="text-red-600">{{ person.role }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          </div>

        <!-- SKELETON TEAM -->
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-red-600">Skelety</h3>

          <ul
            class="grid grid-cols-2 gap-x-6 gap-y-12 space-y-0 sm:grid-cols-3 lg:grid-cols-4 lg:gap-x-8"
          >
            <li v-for="person in techniciansSkeleton" :key="person.name">
              <div class="space-y-4">
                <div class="aspect-w-2 aspect-h-3">
                  <img
                    class="object-cover shadow-lg rounded-lg"
                    :src="person.imageUrl"
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div class="space-y-2">
                  <div class="text-lg leading-6 font-medium space-y-1">
                    <h3>{{ person.name }}</h3>
                    <p class="text-red-600">{{ person.role }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- CAM TEAM -->
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-red-600">CAM</h3>

          <ul
            class="grid grid-cols-2 gap-x-6 gap-y-12 space-y-0 sm:grid-cols-3 lg:grid-cols-4 lg:gap-x-8"
          >
            <li v-for="person in techniciansCam" :key="person.name">
              <div class="space-y-4">
                <div class="aspect-w-2 aspect-h-3">
                  <img
                    class="object-cover shadow-lg rounded-lg"
                    :src="person.imageUrl"
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div class="space-y-2">
                  <div class="text-lg leading-6 font-medium space-y-1">
                    <h3>{{ person.name }}</h3>
                    <p class="text-red-600">{{ person.role }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- DELIVERY TEAM -->
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-red-600">Rozvoz / Svoz zakázek</h3>

          <ul
            class="grid grid-cols-2 gap-x-6 gap-y-12 space-y-0 sm:grid-cols-3 lg:grid-cols-4 lg:gap-x-8"
          >
            <li v-for="person in delivery" :key="person.name">
              <div class="space-y-4">
                <div class="aspect-w-2 aspect-h-3">
                  <img
                    class="object-cover shadow-lg rounded-lg"
                    :src="person.imageUrl"
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div class="space-y-2">
                  <div class="text-lg leading-6 font-medium space-y-1">
                    <h3>{{ person.name }}</h3>
                    <p class="text-red-600">{{ person.role }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- MANAGEMENT TEAM -->
        <div class="space-y-4">
          <h3 class="text-2xl font-bold text-red-600">Vedení laboratoře</h3>

          <ul
            class="grid grid-cols-2 gap-x-6 gap-y-12 space-y-0 sm:grid-cols-3 lg:grid-cols-4 lg:gap-x-8"
          >
            <li v-for="person in management" :key="person.name">
              <div class="space-y-4">
                <div class="aspect-w-2 aspect-h-3">
                  <img
                    class="object-cover shadow-lg rounded-lg"
                    :src="person.imageUrl"
                    alt=""
                    loading="lazy"
                  />
                </div>

                <div class="space-y-2">
                  <div class="text-lg leading-6 font-medium space-y-1">
                    <h3>{{ person.name }}</h3>
                    <p class="text-red-600">{{ person.role }}</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          </div>
      </div>
    </div>
  </div>
  <Hiring />
  <GalleryOverview />
</template>

<script>
import Hiring from '@/components/Hiring.vue'
import GalleryOverview from '@/components/GalleryOverview.vue'

const technicians = [
  {
    name: 'Romana Macková',
    role: 'Zubní technik - keramika, kompozita',
    imageUrl: require('@/assets/img/team/Romana-Mackova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Andrea Milotová',
    role: 'Zubní technik - keramika, kompozita, implantáty',
    imageUrl: require('@/assets/img/team/Andrea-Milotova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Klára Dlouhá, DiS.',
    role: 'Zubní technik - keramika, 3D tisk',
    imageUrl: require('@/assets/img/team/Klara-Dlouha.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Tatiana Petrenco',
    role: 'Zubní technik - modely, 3D tisk, fólie',
    imageUrl: require('@/assets/img/team/Tatiana-Petrenco.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
]

const techniciansCad = [
  {
    name: 'Lenka Maňasová',
    role: 'Zubní technik - CAD',
    imageUrl: require('@/assets/img/team/Lenka-Manasova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Adéla Nováková, DiS.',
    role: 'Zubní technik - CAD',
    imageUrl: require('@/assets/img/team/Adela-Novakova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Anna Vráblová, DiS.',
    role: 'Zubní technik - CAD',
    imageUrl: require('@/assets/img/team/Anna-Vrablova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Kristýna Cichrová',
    role: 'Zubní technik - CAD',
    imageUrl: require('@/assets/img/team/Kristyna_Cichrova.jpg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
]

const techniciansSkeleton = [
  {
    name: 'Renata Šenovská, DiS.',
    role: 'CAD technik - snímatelné náhrady',
    imageUrl: require('@/assets/img/team/Renata-Senovska.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Michal Gerych, DiS.',
    role: 'CAD technik',
    imageUrl: require('@/assets/img/team/Michal-Gerych.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Dominik Koukal',
    role: 'Skelety',
    imageUrl: require('@/assets/img/team/Dominik-Koukal.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Nela Hodečková',
    role: 'Skelety',
    imageUrl: require('@/assets/img/team/Nela-Hodeckova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
]

const techniciansCam = [
  {
    name: 'Klára Saidová',
    role: 'CAM - frézovací centrum',
    imageUrl: require('@/assets/img/team/Klara-Saidova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
]

const delivery = [
  {
    name: 'Lubomír Zimmermann',
    role: 'Řidič - rozvoz a svoz zakázek v Brně',
    imageUrl: require('@/assets/img/team/Milan-Havir.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
]

const management = [
  {
    name: 'Jitka Maleňáková',
    role: 'Vedoucí laboratoře a provozu, zástupce CEO',
    imageUrl: require('@/assets/img/team/Jitka-Malenakova.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Ondřej Kudera, MSc.',
    role: 'CEO',
    imageUrl: require('@/assets/img/team/Ondrej-Kudera.jpeg'),
    twitterUrl: '#',
    linkedinUrl: '#',
  },
]

export default {
  components: {
    Hiring,
    GalleryOverview,
  },
  setup() {
    return {
      technicians,
      techniciansCad,
      techniciansSkeleton,
      techniciansCam,
      delivery,
      management,
    }
  },
}
</script>
